import React from 'react'
import { Box, Callout } from '@node-space/ui-components'
import { ConfirmPayeeMatchStatuses, ConfirmPayeeResponse } from 'types/payoutsV2'
import { ConfirmationOfPayeeCalloutType } from '../types'
import { ConfirmationOfPayeeCalloutCta } from './ConfirmationOfPayeeCalloutCta'

interface ConfirmationOfPayeeCalloutProps {
  type: ConfirmationOfPayeeCalloutType
  confirmationOfPayeeCallout: string
  confirmPayeeData: ConfirmPayeeResponse
  editBeneficiary?: boolean
  handleEditBeneficiary?: () => void
}

export const ConfirmationOfPayeeCallout = ({
  type,
  confirmationOfPayeeCallout,
  confirmPayeeData,
  editBeneficiary,
  handleEditBeneficiary,
}: ConfirmationOfPayeeCalloutProps) => {
  return (
    <>
      {confirmationOfPayeeCallout && (
        <Box paddingT={16}>
          <Callout
            variant={
              confirmPayeeData?.matchStatus === ConfirmPayeeMatchStatuses.MATCH ? 'info' : 'warning'
            }
          >
            <div className="flex items-center gap-1 flex-wrap">
              <span>{confirmationOfPayeeCallout}</span>
              {editBeneficiary && (
                <ConfirmationOfPayeeCalloutCta
                  type={type}
                  handleEditBeneficiary={handleEditBeneficiary}
                />
              )}
            </div>
          </Callout>
        </Box>
      )}
    </>
  )
}
